<forge-card [outlined]="outlined">
    <div *ngIf="isLoaded">
        <form #form="ngForm">
            <div fxLayout="column" fxLayoutAlign="space-between">
                <metadata-panel ngModelGroup="pnl_edit" [metadata]="metadata" [model]="entity" [viewOnly]="!saveable" class="standardMetadata">
                </metadata-panel>
            </div>
        </form>
        <div *ngIf="saveable" class="actions" fxLayout="row" fxLayoutAlign="end center">
            <forge-button variant="outlined" (click)="onCancel()" telemetry="Submission-InfoCardCancel">
                
                    Cancel
                </forge-button>

            <forge-button variant="raised" [disabled]="!formValid" (click)="onSave()" telemetry="Submission-InfoCardSave">
                
                    Save
                </forge-button>
        </div>
    </div>

    <busy-indicator *ngIf="!isLoaded" [page]="true"></busy-indicator>
</forge-card>
